import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function InfoChangeList(props) {
  const Config = {
    purchase: {
      apiPath: '/archives/compVendorChanged/pageList',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/supplier/info-change/detail',
      searchBarPlaceholder: '供应商名称/编码',
      orderProperty: 'createTime',
      tabs: ['全部'],
      arrEnumField: [
        {
          mainKey: 'B02_Company_Changed_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        }
      ]
    },
    sale: {
      apiPath: '/archives/compCustomerChanged/pageList',
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/customer/my-info-change/detail',
      searchBarPlaceholder: '客户名称/编码',
      orderProperty: 'createTime',
      tabs: ['全部'],
      arrEnumField: [
        {
          mainKey: 'B02_Company_Changed_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    decimalPlace,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setListField,
    setTotalField,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.ccXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.ccXkNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                'companyChange',
                                item.status
                              )
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.customerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>申请日期</label>
                          <div>{formatDate(item.reqDate, 'YYYY-MM-DD')}</div>
                        </li>
                        <li>
                          <label>同步状态</label>
                          <div>
                            <span
                              className={
                                'u-sign ' +
                                CommonFns.getStatusClass(
                                  'sync',
                                  item.syncStatus
                                )
                              }
                            >
                              {item.syncStatusName}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

InfoChangeList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(InfoChangeList);
